import { PublicShell } from '../components/PublicShell';
import { useEnter } from '../lib/motion';

/**
 * Allgemeine Geschäftsbedingungen.
 *
 * ENTWURF. Volltext in `docs/recht/agb-entwurf.md`, dort steht auch, was
 * bewusst nicht drinsteht und warum. Vor dem ersten zahlenden Kunden
 * anwaltlich prüfen lassen.
 *
 * Der Text liegt als Datenstruktur vor und nicht als JSX: so bleibt die
 * Nummerierung beim Umstellen von Absätzen stabil und der Inhalt lässt sich
 * mit der Fassung im Repo abgleichen, ohne durch Markup zu lesen.
 */

interface Absatz {
  /** Nummer in Klammern, wie im Vertragstext üblich. */
  nr: number;
  text: string;
  /** Hebt den Absatz hervor, wenn er eine Zusage oder einen Ausschluss trägt. */
  betont?: boolean;
}

interface Paragraf {
  nr: number;
  titel: string;
  absaetze: Absatz[];
}

const PARAGRAFEN: Paragraf[] = [
  {
    nr: 1,
    titel: 'Geltungsbereich, Vertragspartner',
    absaetze: [
      {
        nr: 1,
        text: 'Diese Bedingungen gelten für alle Verträge über die Nutzung der Software ilovecookies zwischen Jonas Fischer, Einzelunternehmer, Erftstraße 13-15, 41460 Neuss, kontakt@jif-works.de, nachfolgend Anbieter, und dem Kunden.',
      },
      {
        nr: 2,
        betont: true,
        text: 'Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB, an juristische Personen des öffentlichen Rechts und an öffentlich-rechtliche Sondervermögen. Ein Vertragsschluss mit Verbrauchern kommt nicht zustande. Der Kunde sichert bei der Registrierung zu, in Ausübung seiner gewerblichen oder selbständigen beruflichen Tätigkeit zu handeln.',
      },
      {
        nr: 3,
        text: 'Abweichende oder ergänzende Bedingungen des Kunden werden nicht Vertragsbestandteil, auch wenn der Anbieter ihnen nicht ausdrücklich widerspricht und die Leistung in Kenntnis dieser Bedingungen erbringt.',
      },
    ],
  },
  {
    nr: 2,
    titel: 'Gegenstand des Vertrags',
    absaetze: [
      {
        nr: 1,
        text: 'Der Anbieter stellt dem Kunden eine Software zur Verfügung, mit der auf Websites des Kunden eine Einwilligung für Cookies und vergleichbare Technologien eingeholt, dokumentiert und widerrufen werden kann. Dazu gehören ein Einwilligungsbanner, das Zurückhalten von Diensten bis zur Entscheidung des Besuchers, ein Protokoll der Entscheidungen und eine automatische Erfassung der auf der Website eingesetzten Cookies.',
      },
      {
        nr: 2,
        betont: true,
        text: 'Die Software unterstützt den Kunden bei der Umsetzung von Anforderungen aus der DSGVO und dem TDDDG. Sie stellt die Rechtskonformität der Website des Kunden nicht her und sichert sie nicht zu. Ob eine Website den rechtlichen Anforderungen genügt, hängt von Entscheidungen ab, die der Kunde trifft: welche Dienste er einsetzt, welchen Zweckkategorien er sie zuordnet, wie er das Banner beschriftet und was in seiner Datenschutzerklärung steht.',
      },
      {
        nr: 3,
        text: 'Die automatische Einordnung gefundener Cookies beruht auf einer Wissensbasis bekannter Dienste. Sie ist eine Hilfe, keine rechtliche Prüfung. Einträge, die der Anbieter nicht sicher zuordnen kann, werden dem Kunden ausdrücklich zur Prüfung vorgelegt. Die abschließende Einordnung verantwortet der Kunde.',
      },
      {
        nr: 4,
        text: 'Der Anbieter schuldet keine Beratung zu Datenschutz oder Wettbewerbsrecht. Hinweise im Dashboard oder in der Dokumentation sind keine Rechtsberatung.',
      },
    ],
  },
  {
    nr: 3,
    titel: 'Vertragsschluss, Konto',
    absaetze: [
      {
        nr: 1,
        text: 'Der Vertrag kommt mit der Bestätigung der Registrierung durch den Anbieter zustande, spätestens mit der Bereitstellung des Zugangs.',
      },
      {
        nr: 2,
        text: 'Der Kunde hält seine Zugangsdaten geheim und meldet dem Anbieter unverzüglich, wenn er Anhaltspunkte für eine unbefugte Nutzung hat.',
      },
      {
        nr: 3,
        text: 'Der Kunde darf weitere Nutzer anlegen. Er steht für deren Handeln ein wie für eigenes.',
      },
    ],
  },
  {
    nr: 4,
    titel: 'Leistungsumfang, Verfügbarkeit',
    absaetze: [
      {
        nr: 1,
        text: 'Der Umfang richtet sich nach dem gewählten Tarif. Maßgeblich sind die Angaben auf der Preisseite in der bei Vertragsschluss geltenden Fassung.',
      },
      {
        nr: 2,
        betont: true,
        text: 'Der Anbieter betreibt die Auslieferung über ein weltweites Netz und strebt eine Verfügbarkeit von 99,5 Prozent im Monatsmittel an. Ausgenommen sind Zeiten der Wartung sowie Störungen, die der Anbieter nicht zu vertreten hat, insbesondere Ausfälle bei Vorleistern. Eine Verfügbarkeit wird nicht zugesichert.',
      },
      {
        nr: 3,
        text: 'Wartungsarbeiten, die die Erreichbarkeit voraussichtlich länger als 15 Minuten beeinträchtigen, kündigt der Anbieter nach Möglichkeit 48 Stunden vorher per E-Mail an.',
      },
      {
        nr: 4,
        text: 'Der Anbieter darf die Software weiterentwickeln. Funktionen, die der Kunde im Zeitpunkt des Vertragsschlusses nutzt, werden nicht ohne sachlichen Grund und nicht ohne Ankündigung von drei Monaten entfernt.',
      },
    ],
  },
  {
    nr: 5,
    titel: 'Messung, Tarifgrenzen, Höherstufung',
    absaetze: [
      {
        nr: 1,
        text: 'Die Einstufung richtet sich nach der Zahl der Unterseiten einer Domain und nach der Zahl ausgelieferter Banner.',
      },
      {
        nr: 2,
        text: 'Zählweise der Unterseiten: Gezählt wird die kanonische Adresse einer Seite. Suchparameter und Anker bleiben außer Betracht. Paginierte Archive, Suchergebnisseiten und Filterseiten gelten nicht als eigene Unterseiten. Subdomains derselben registrierbaren Domain zählen zu dieser Domain und nicht gesondert.',
      },
      {
        nr: 3,
        text: 'Zählweise der Auslieferungen: Gezählt wird jede Auslieferung des Einwilligungsbanners an einen Browser. Die Zählung erfolgt gebündelt; sie kann aus technischen Gründen geringfügig nach unten abweichen. Eine Abweichung zu Lasten des Kunden findet nicht statt.',
      },
      {
        nr: 4,
        betont: true,
        text: 'Keine automatische Höherstufung: Überschreitet eine Domain die Unterseitengrenze ihres Tarifs, teilt der Anbieter dies dem Kunden in Textform mit. Der Kunde hat 30 Tage Zeit, den Tarif zu wechseln oder die Zahl der Unterseiten zu verringern. Eine Erhöhung des Entgelts tritt erst mit der Zustimmung des Kunden ein. Stimmt der Kunde nicht zu und verringert er die Seitenzahl nicht, kann der Anbieter den Vertrag mit einer Frist von einem Monat zum Monatsende kündigen.',
      },
      {
        nr: 5,
        betont: true,
        text: 'Keine Abschaltung wegen Überschreitung: Der Anbieter liefert das Banner auch bei Überschreitung von Grenzwerten weiter aus. Unberührt bleiben die Rechte des Anbieters bei Zahlungsverzug (§ 6 Abs. 6) und bei Missbrauch (§ 8 Abs. 4).',
      },
      {
        nr: 6,
        text: 'Der Kunde kann die gemessenen Werte jederzeit im Dashboard einsehen. Hält er eine Messung für unrichtig, teilt er dies mit; der Anbieter prüft und korrigiert die Abrechnung, wenn die Beanstandung zutrifft.',
      },
    ],
  },
  {
    nr: 6,
    titel: 'Preise, Umsatzsteuer, Zahlung',
    absaetze: [
      { nr: 1, text: 'Es gelten die Preise des gewählten Tarifs je Domain und Monat.' },
      {
        nr: 2,
        betont: true,
        text: 'Der Anbieter ist Kleinunternehmer im Sinne des § 19 UStG. Umsatzsteuer wird nicht berechnet und nicht ausgewiesen. Die genannten Beträge sind die Endbeträge. Entfällt die Kleinunternehmerregelung, tritt die gesetzliche Umsatzsteuer hinzu; der Anbieter teilt dies mindestens einen Monat vorher mit. Die Preisgarantie nach Absatz 4 bezieht sich auf den Nettobetrag und wird hiervon nicht berührt.',
      },
      {
        nr: 3,
        text: 'Für Auslieferungen über dem Kontingent des Tarifs berechnet der Anbieter 1 Euro je angefangener weiterer Million. Der Aufschlag wird mit der Monatsrechnung abgerechnet.',
      },
      {
        nr: 4,
        betont: true,
        text: 'Preisgarantie: Der bei Vertragsschluss vereinbarte Preis gilt für 24 Monate ab Vertragsbeginn, auch wenn der Anbieter seine Preisliste ändert.',
      },
      {
        nr: 5,
        text: 'Ab der fünften Domain eines Kunden wird auf jede weitere Domain ein Nachlass von 30 Prozent gewährt.',
      },
      {
        nr: 6,
        text: 'Die Rechnung ist innerhalb von 14 Tagen ohne Abzug fällig. Bei Zahlungsverzug von mehr als 30 Tagen kann der Anbieter die Leistung nach vorheriger Ankündigung in Textform und einer Nachfrist von weiteren 14 Tagen einstellen. Die gesetzlichen Verzugsregelungen bleiben unberührt.',
      },
      { nr: 7, text: 'Bei einem Tarifwechsel innerhalb eines Monats wird anteilig abgerechnet.' },
      {
        nr: 8,
        text: 'Der Tarif Frei wird unentgeltlich bereitgestellt. Der Anbieter kann ihn mit einer Frist von drei Monaten einstellen oder ändern. Ein Anspruch auf Bereitstellung besteht nicht.',
      },
    ],
  },
  {
    nr: 7,
    titel: 'Auftragsverarbeitung',
    absaetze: [
      {
        nr: 1,
        text: 'Soweit der Anbieter bei der Erbringung der Leistung personenbezogene Daten von Besuchern der Website des Kunden verarbeitet, handelt er als Auftragsverarbeiter. Verantwortlicher im Sinne des Art. 4 Nr. 7 DSGVO ist der Kunde.',
      },
      {
        nr: 2,
        text: 'Es gilt der Vertrag über die Verarbeitung personenbezogener Daten im Auftrag in seiner jeweils vereinbarten Fassung. Er ist Bestandteil dieses Vertrags. Bei Widersprüchen geht er diesen Bedingungen vor.',
      },
      {
        nr: 3,
        text: 'Der Anbieter verarbeitet die Einwilligungsnachweise nicht für eigene Zwecke. Die Wissensbasis zur Einordnung von Cookies wird ausschließlich aus Scan-Ergebnissen gepflegt, nicht aus Einwilligungsdaten.',
      },
    ],
  },
  {
    nr: 8,
    titel: 'Pflichten des Kunden',
    absaetze: [
      {
        nr: 1,
        text: 'Der Kunde verantwortet die Inhalte seiner Website, die Auswahl der dort eingesetzten Dienste, deren Zuordnung zu Zweckkategorien, die Texte des Banners und seine Datenschutzerklärung.',
      },
      {
        nr: 2,
        text: 'Der Kunde baut das bereitgestellte Script so ein, wie in der Anleitung beschrieben, insbesondere vor allen anderen Scripten im Kopf der Seite. Wird davon abgewichen, kann der Anbieter nicht dafür einstehen, dass Dienste vor der Einwilligung zurückgehalten werden.',
      },
      {
        nr: 3,
        text: 'Der Kunde setzt die Software nur auf Websites ein, die er betreibt oder für die er beauftragt ist.',
      },
      {
        nr: 4,
        text: 'Der Kunde setzt die Software nicht für rechtswidrige Zwecke ein und belastet die Infrastruktur nicht über das vertraglich vorgesehene Maß hinaus. Bei erheblichen Verstößen kann der Anbieter den Zugang nach Ankündigung sperren; bei Gefahr für den Betrieb oder für Dritte auch ohne Ankündigung, mit unverzüglicher Unterrichtung.',
      },
      {
        nr: 5,
        text: 'Der Kunde stellt den Anbieter von Ansprüchen Dritter frei, die auf einer Verletzung der Pflichten aus diesem Paragrafen beruhen, einschließlich angemessener Kosten der Rechtsverteidigung. Dies gilt nicht, soweit der Kunde die Pflichtverletzung nicht zu vertreten hat.',
      },
    ],
  },
  {
    nr: 9,
    titel: 'Haftung',
    absaetze: [
      {
        nr: 1,
        text: 'Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei der Verletzung von Leben, Körper oder Gesundheit, nach dem Produkthaftungsgesetz sowie im Umfang einer übernommenen Garantie.',
      },
      {
        nr: 2,
        text: 'Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei der Verletzung einer Pflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Kunde regelmäßig vertrauen darf. In diesem Fall ist die Haftung auf den bei Vertragsschluss vorhersehbaren, vertragstypischen Schaden begrenzt.',
      },
      {
        nr: 3,
        text: 'Die Haftung nach Absatz 2 ist der Höhe nach begrenzt auf das vom Kunden in den letzten zwölf Monaten vor dem schadensauslösenden Ereignis gezahlte Entgelt, mindestens jedoch auf 1.000 Euro.',
      },
      {
        nr: 4,
        betont: true,
        text: 'Der Anbieter haftet nicht für Bußgelder, Abmahnkosten oder Schadensersatzansprüche, die gegen den Kunden wegen der Gestaltung oder des Inhalts seiner Website verhängt oder geltend gemacht werden, soweit diese auf Entscheidungen des Kunden nach § 2 Abs. 2 und § 8 Abs. 1 beruhen.',
      },
      {
        nr: 5,
        text: 'Eine Änderung der Beweislast zum Nachteil des Kunden ist mit den vorstehenden Regelungen nicht verbunden.',
      },
      {
        nr: 6,
        text: 'Die Haftungsbeschränkungen gelten auch für die persönliche Haftung von Mitarbeitern, Vertretern und Erfüllungsgehilfen des Anbieters.',
      },
    ],
  },
  {
    nr: 10,
    titel: 'Laufzeit, Kündigung, Daten nach Vertragsende',
    absaetze: [
      {
        nr: 1,
        text: 'Der Vertrag läuft auf unbestimmte Zeit. Er kann von beiden Seiten mit einer Frist von einem Monat zum Monatsende in Textform gekündigt werden. Bei Jahreszahlung endet der Vertrag zum Ende des bezahlten Jahres.',
      },
      { nr: 2, text: 'Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.' },
      {
        nr: 3,
        text: 'Nach Vertragsende stellt der Anbieter die Auslieferung ein. Der Kunde entfernt das Script von seinen Websites.',
      },
      {
        nr: 4,
        text: 'Der Kunde kann die Einwilligungsnachweise bis zu 30 Tage nach Vertragsende exportieren. Danach löscht der Anbieter alle Daten des Kunden, soweit keine gesetzliche Aufbewahrungspflicht entgegensteht. Der Kunde ist selbst dafür verantwortlich, die Nachweise so lange vorzuhalten, wie er sie zur Erfüllung seiner eigenen Rechenschaftspflicht nach Art. 5 Abs. 2 DSGVO benötigt.',
      },
    ],
  },
  {
    nr: 11,
    titel: 'Änderungen dieser Bedingungen',
    absaetze: [
      {
        nr: 1,
        text: 'Der Anbieter kann diese Bedingungen ändern, wenn dies zur Anpassung an eine geänderte Rechtslage, an höchstrichterliche Rechtsprechung oder an eine Änderung des Leistungsangebots erforderlich ist und der Kunde dadurch nicht unangemessen benachteiligt wird.',
      },
      {
        nr: 2,
        text: 'Änderungen teilt der Anbieter mindestens sechs Wochen vor ihrem Wirksamwerden in Textform mit. Widerspricht der Kunde nicht innerhalb von sechs Wochen ab Zugang, gelten die Änderungen als angenommen. Auf diese Folge weist der Anbieter in der Mitteilung gesondert hin. Widerspricht der Kunde, kann jede Seite den Vertrag zum Zeitpunkt des Wirksamwerdens kündigen.',
      },
      {
        nr: 3,
        text: 'Absatz 1 und 2 gelten nicht für Änderungen der Hauptleistungspflichten, insbesondere nicht für Preiserhöhungen. Dafür gilt § 6 Abs. 4.',
      },
    ],
  },
  {
    nr: 12,
    titel: 'Rechte an der Software',
    absaetze: [
      {
        nr: 1,
        text: 'Der Kunde erhält für die Laufzeit des Vertrags ein einfaches, nicht übertragbares Recht, die Software im vertraglich vorgesehenen Umfang zu nutzen.',
      },
      {
        nr: 2,
        text: 'Betreut der Kunde als Agentur Websites Dritter, darf er die Software für diese Websites einsetzen. Eine Weitergabe der Zugangsdaten an Dritte ist unzulässig; stattdessen sind eigene Nutzer anzulegen.',
      },
      { nr: 3, text: 'Alle weiteren Rechte verbleiben beim Anbieter.' },
    ],
  },
  {
    nr: 13,
    titel: 'Schlussbestimmungen',
    absaetze: [
      { nr: 1, text: 'Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.' },
      {
        nr: 2,
        text: 'Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag Neuss.',
      },
      {
        nr: 3,
        text: 'Änderungen und Ergänzungen bedürfen der Textform. Das gilt auch für die Aufhebung dieses Formerfordernisses.',
      },
      {
        nr: 4,
        text: 'Sollte eine Bestimmung unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
      },
    ],
  },
];

export function AgbPage() {
  const ref = useEnter<HTMLDivElement>([]);

  return (
    <PublicShell>
      <div ref={ref} className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="text-3xl font-semibold tracking-tight">Allgemeine Geschäftsbedingungen</h1>
        <p className="mt-2 text-sm text-[var(--text-muted)]">Fassung vom 27. September 2026</p>

        <div className="mt-6 rounded-xl border border-warn-500/40 bg-warn-100 px-4 py-3 text-sm text-[#7c2d12]">
          Entwurf. Vor dem ersten zahlenden Kunden anwaltlich prüfen lassen.
        </div>

        <div className="mt-8 flex flex-col gap-8">
          {PARAGRAFEN.map((paragraf) => (
            <section key={paragraf.nr}>
              <h2 className="text-lg font-semibold tracking-tight">
                § {paragraf.nr} {paragraf.titel}
              </h2>
              <ol className="mt-2 flex flex-col gap-2.5">
                {paragraf.absaetze.map((absatz) => (
                  <li
                    key={absatz.nr}
                    className={
                      absatz.betont
                        ? 'text-[15px] leading-relaxed font-medium text-[var(--text)]'
                        : 'text-[15px] leading-relaxed text-[var(--text-muted)]'
                    }
                  >
                    <span className="tabular mr-1.5 text-[var(--text-muted)]">({absatz.nr})</span>
                    {absatz.text}
                  </li>
                ))}
              </ol>
            </section>
          ))}
        </div>
      </div>
    </PublicShell>
  );
}
